import "./App.css";
import React, { useEffect, useState, lazy, Suspense } from "react";
import Home from "./components/Home";
import About from "./components/pages/About";
import Playhouse from "./components/pages/Playhouse";
import Reviews from "./components/pages/Reviews";
import Ranch from "./components/pages/Ranch";
import Cottage from "./components/pages/Cottage";
import Clubhouse from "./components/pages/Clubhouse";
import SweetShoppe from "./components/pages/SweetShoppe";
import Customize from "./components/pages/Customize";
import Login from "./components/pages/Login";
import FAQ from "./components/pages/FAQ";
import Ordering from "./components/pages/Ordering";
import CompletedProjects from "./components/CompletedProjects";
import Contact from "./components/Contact";
import {
	BrowserRouter as Router,
	Route,
	Routes,
	Navigate,
	useLocation,
} from "react-router-dom";
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

// Admin dashboard — lazy loaded so it never adds weight to the public site
const AdminDashboard = lazy(() => import("./components/admin/AdminDashboard"));

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIRESTORE_API_KEY,
	authDomain: "wishuponaplayhouse.firebaseapp.com",
	projectId: "wishuponaplayhouse",
	storageBucket: "wishuponaplayhouse.firebasestorage.app",
	messagingSenderId: "513377368862",
	appId: "1:513377368862:web:eadda2a0b7bb141ffa670f",
};

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);

function ScrollToTop() {
	const { pathname } = useLocation();
	useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
	return null;
}

function App() {
	// null = still checking, false = not logged in, object = Firebase user
	const [authUser, setAuthUser] = useState(null);
	const [authChecked, setAuthChecked] = useState(false);

	useEffect(() => {
		const allowedEmail = process.env.REACT_APP_ADMIN_EMAIL;
		const unsub = onAuthStateChanged(auth, (user) => {
			if (user && allowedEmail && user.email !== allowedEmail) {
				// Signed in with an unauthorised account — kick them out immediately
				signOut(auth);
				setAuthUser(null);
			} else {
				setAuthUser(user);
			}
			setAuthChecked(true);
		});
		return unsub;
	}, []);

	// Don't render protected routes until Firebase has confirmed auth state
	if (!authChecked) return null;

	return (
		<Router>
			<ScrollToTop />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/about" element={<About />} />
				<Route path="/playhouses" element={<Playhouse />} />
				<Route path="/reviews" element={<Reviews />} />
				<Route path="/playhouses/ranch" element={<Ranch />} />
				<Route path="/playhouses/cottage" element={<Cottage />} />
				<Route path="/playhouses/clubhouse" element={<Clubhouse />} />
				<Route path="/playhouses/sweet-shoppe" element={<SweetShoppe />} />
				<Route path="/playhouses/customize" element={<Customize />} />
				<Route path="/playhouses/faq" element={<FAQ />} />
				<Route path="/playhouses/ordering" element={<Ordering />} />
				<Route path="/gallery" element={<CompletedProjects />} />
				<Route path="/completed-projects" element={<Navigate to="/gallery" replace />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="/login" element={<Login />} />
				<Route
					path="/admin"
					element={
						authUser ? (
							<Suspense
								fallback={
									<div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", fontFamily: "system-ui, sans-serif", color: "#888", fontSize: 14 }}>
										Loading admin…
									</div>
								}
							>
								<AdminDashboard />
							</Suspense>
						) : (
							<Navigate to="/login" replace />
						)
					}
				/>
			</Routes>
		</Router>
	);
}

export default App;
